export class NationalIdRequest {
	NationalId: string;
}
